import React from "react";

const CancellationAndRefund = () => (
  <div className="min-h-screen bg-black text-white flex flex-col items-center py-12 px-4">
    <div className="w-full max-w-2xl mx-auto">
      <h1 className="text-4xl font-semibold font-primary text-center mb-2">
        Cancellation & Refund Policy
      </h1>
      <p className="text-gray-500 text-center mb-8 text-sm">
        Updated on 26th March, 2026
      </p>
      <p className="mb-8 text-lg leading-relaxed">
        At FOZZIL, we aim to provide seamless access to our AI-driven products
        and services including T.A.E.L.S, ZYPHER AI, FOZZIL MEDOS,
        FOZZIL ARK, and related services. We believe in
        flexibility and transparency when it comes to your subscription or
        purchase decisions.
      </p>
      <h2 className="text-2xl font-bold mb-3 mt-10">Subscription Refunds</h2>
      <p className="mb-4 text-lg leading-relaxed">
        For payments made via FOZZIL Pay, refunds are processed back to the original payment source (Bank Account, Card, or UPI) within 5–7 business days of approval.
      </p>
      <p className="mb-8 text-lg leading-relaxed">
        FOZZIL INDUSTRIES does not charge additional fees for processing refunds. However, specific refund eligibility may vary based on the service or subscription plan purchased.
      </p>

      <h2 className="text-2xl font-bold mb-3 mt-10">Hardware & Product Returns (FOZZIL Store)</h2>
      <p className="mb-4 text-lg leading-relaxed">
        Hardware products purchased through the FOZZIL Store (including FOZZIL ARK and FOZZIL ARK Pro) may be returned within 14 days of delivery, provided the product is in its original condition and packaging. Return shipping costs are borne by the buyer unless the product is defective.
      </p>
      <p className="mb-8 text-lg leading-relaxed">
        For defective or damaged products, please contact support within 48 hours of receiving the product. FOZZIL will arrange a replacement or full refund at no additional cost.
      </p>

      <h2 className="text-2xl font-bold mb-3 mt-10">Subscription Cancellations</h2>
      <p className="mb-4 text-lg leading-relaxed">
        Cancellations for services like T.A.E.L.S, MEDOS, or Ecosystem subscriptions must be initiated through the respective product dashboard or your FOZZIL Account. You may cancel your subscription or service at any time.
      </p>
      <ul className="mb-8 text-lg list-disc list-inside space-y-1">
        <li>
          Once cancelled, your access to premium features will continue until the
          end of your current billing cycle.
        </li>
        <li>You will not be charged again unless you re-subscribe.</li>
        <li>
          Cancellation is instant, and no further payments will be collected.
        </li>
        <li>
          To cancel, go to your Account Settings or contact us at{" "}
          <a
            href="mailto:support@fozzil.in"
            className="underline hover:text-blue-400"
          >
            support@fozzil.in
          </a>{" "}
          with your registered email ID and Order/Subscription reference.
        </li>
      </ul>

      <h2 className="text-2xl font-bold mb-3 mt-10">Order Cancellations (FOZZIL Store)</h2>
      <p className="mb-8 text-lg leading-relaxed">
        Orders placed through the FOZZIL Store may be cancelled before they are shipped. Once an order has been dispatched, it cannot be cancelled but may be returned under our return policy. To cancel a pending order, visit your Orders page at store.fozzil.in or contact support.
      </p>

      <h2 className="text-2xl font-bold mb-3 mt-10">Contact</h2>
      <p className="mb-2 text-lg">
        For questions or concerns regarding cancellations or refunds, please
        contact:
        <br />
        <span className="block mt-2">
          📩{" "}
          <a
            href="mailto:legal@fozzil.in"
            className="underline hover:text-blue-400"
          >
            legal@fozzil.in
          </a>
        </span>
      </p>
    </div>
  </div>
);

export default CancellationAndRefund;
